/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import * as React from 'react';
import type { SVGProps } from 'react';
const SvgGpu = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 16 12"
    {...props}
  >
    <g fill="#fff">
      <path d="M1.69 10.687c0 .362-.013.655.003.945.018.31-.086.439-.427.329V9.22C.53 8.629.958 7.88.86 7.25c-.025-.16.163-.353.253-.532l.11.035V5.236l-.118.047c-.087-.179-.266-.37-.245-.534.08-.621-.295-1.345.362-1.964V.437c-.3 0-.59-.013-.88.004C.035.459-.065.335.039 0h1.634v1.626H13.544c1.61 0 2.452.885 2.454 2.574 0 1.341.002 2.683 0 4.024-.002 1.51-.903 2.46-2.351 2.463-3.792.005-7.585 0-11.377 0H1.69Zm6.944-4.554c-.004 1.74 1.342 3.142 3.007 3.13 1.634-.009 2.977-1.411 2.98-3.113.006-1.732-1.346-3.13-3.018-3.12-1.659.01-2.968 1.375-2.97 3.101v.002Z" />
      <path d="M11.61 5.48c.364-.01.655.285.657.662.003.374-.288.68-.646.676-.345-.002-.616-.277-.633-.64-.016-.38.26-.689.62-.698h.003ZM10.797 5.694c-.277.015-.888-.646-.863-.936.027-.32.368-.496.627-.294.21.164.403.369.555.59.178.259-.018.623-.319.64ZM12.346 6.624c.375-.015 1.024.607.969.87-.033.159-.19.36-.333.41-.3.106-.983-.636-.889-.954.045-.147.197-.259.25-.326h.002ZM10.606 7.785c-.16.147-.404.158-.558.007a.157.157 0 0 1-.046-.07c-.047-.142-.054-.354.02-.467.137-.212.32-.42.53-.545.127-.075.404-.05.5.048.094.097.117.404.037.515a3.445 3.445 0 0 1-.481.512h-.002ZM12.476 5.694c-.3 0-.52-.363-.345-.627.157-.236.365-.452.588-.618.258-.19.601.021.61.337.007.266-.594.906-.853.906v.002Z" />
    </g>
  </svg>
);

export default SvgGpu;
